import React from 'react';
import { Section, SectionHeading, Reveal } from './ui/Section';

const PROBLEMS = [
  {
    voice: '会計ソフトの月額費用が、毎年じわじわ上がっていく。',
    tag: 'コスト',
  },
  {
    voice: '会社の数字をクラウドに預けることに、どうしても不安が残る。',
    tag: 'セキュリティ',
  },
  {
    voice: 'AI機能は便利だが、利用回数に上限があって結局使い切れない。',
    tag: '使い勝手',
  },
  {
    voice: '数字は出るが、経営状況がひと目で分かる形になっていない。',
    tag: '可視化',
  },
];

const Problem: React.FC = () => (
  <Section id="problem" tone="muted">
    <SectionHeading
      eyebrow="Issues"
      title={<>その会計ソフト、<br className="sm:hidden" />こんな不満はありませんか</>}
      lead="中小企業の経理現場で、私たちが実際に多くうかがってきた声です。"
    />

    <div className="mt-14 grid gap-5 sm:grid-cols-2">
      {PROBLEMS.map((p, i) => (
        <Reveal key={p.tag} delay={i * 0.08}>
          <div className="card card-pad h-full">
            <span className="text-eyebrow uppercase num text-body-faint">{p.tag}</span>
            <p className="mt-3 text-lg font-bold leading-relaxed text-ink-900">
              「{p.voice}」
            </p>
          </div>
        </Reveal>
      ))}
    </div>

    {/* 課題 → 解決 への導線 */}
    <Reveal delay={0.3}>
      <div className="mt-14 flex flex-col items-center">
        <div className="h-10 w-px bg-line-strong" />
        <div className="rounded-card bg-ink-900 px-8 py-6 text-center sm:px-12">
          <p className="text-small font-bold uppercase num tracking-[0.18em] text-brand-300">
            Our Answer
          </p>
          <p className="mt-3 text-xl font-bold leading-relaxed text-white sm:text-2xl">
            AIを<span className="text-brand-400">お客様のPCの中</span>で動かす。
            <br className="sm:hidden" />
            それが、サクミエ会計の答えです。
          </p>
        </div>
      </div>
    </Reveal>
  </Section>
);

export default Problem;
